import styled from 'styled-components';

import type { ReactNode } from 'react';

type BadgeProps = {
  borderColor?: string;
  textColor?: string;
  backgroundColor?: string;
  size?: 'default' | 'sm';
  children: ReactNode;
};

export default function Badge(props: BadgeProps) {
  return <BadgeContainer {...props}>{props.children}</BadgeContainer>;
}

const BadgeContainer = styled.div<{
  textColor?: string;
  borderColor?: string;
  backgroundColor?: string;
  size?: 'default' | 'sm';
}>`
  background-color: ${props => props.backgroundColor || 'var(--gray-700)'};
  color: ${props => props.textColor || 'inherit'};
  padding: ${props =>
    props.size === 'sm'
      ? 'var(--spacing-xs) var(--spacing-sm)'
      : 'var(--spacing-sm) var(--spacing-md)'};
  width: fit-content;
  border: 1px solid
    ${props => (props.borderColor ? props.borderColor : 'var(--border-subtle)')};
  border-radius: 999px;
  display: inline-flex;
  gap: var(--spacing-sm);
  align-items: center;
  margin: 0;
  font-family: var(--font-primary);
  font-size: ${props =>
    props.size === 'sm' ? 'var(--text-xs)' : 'var(--text-sm)'};
  font-weight: var(--font-weight-medium);
  font-style: normal;
  line-height: ${props =>
    props.size === 'sm' ? 'var(--leading-text-xs)' : 'var(--leading-text-sm)'};
`;
